import { Injectable } from '@angular/core'

@Injectable()

export class ArrayHelper {
    /* DEPRECATED We should use the one on core components*/
    diff(from, comparedWith) {
        return from.filter(function (i) {
            return comparedWith.indexOf(i) < 0
        });
    };

    updateObject(old: any = {}, newValue: any = {}, addNewKeys = false) {
        const value = newValue || {};
        for (const i in old) {
            if (value.hasOwnProperty(i)) {
                old[i] = value[i]
            }
        }
        if (addNewKeys) {
            const newKeys = this.diff(Object.keys(value), Object.keys(old));
            for (const i in newKeys) {
                if (value.hasOwnProperty(newKeys[i])) {
                    old[newKeys[i]] = value[newKeys[i]]
                }
            }
        }
        return old;
    }

    clean(array) {
        if (array && typeof array === 'object') {
            const keys = Object.keys(array);
            for (const i in keys) {
                const k = keys[i];
                if (array[k] == null || typeof array[k] === 'undefined') {
                    delete  array[k]
                }
            }
        }
        return array
    }

    cloneDeep(mainArray) {
        return JSON.parse(JSON.stringify(mainArray))
    }

    orderBy<T>(array: Array<T>, orderField: keyof T, orderDesc = false): Array<T> {
        array.sort((itemA: T, itemB: T) => {
            const valueA = itemA[orderField];
            const valueB = itemB[orderField];
            return orderDesc
                ? valueA > valueB ? -1 : 1
                : valueB > valueA ? -1 : 1
        });
        return array
    }
}
